import React from 'react';
import styled from 'styled-components';


export default function FAQPage() {
  return (
    <h1>This is static FAQ</h1>
  );
}
